import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecabs() {



const cardData =
{
  keyword: 'Pune to Indore Cabs',
  heading: 'Lotus Cab: Pune to Indore Cabs',

  headingDescription: 'Lotus Cab offers professionally managed Pune to Indore Cabs designed for long-distance interstate travel with maximum comfort, safety, and reliability. The Pune to Indore route covers approximately 600+ kilometers and requires experienced highway drivers who are familiar with Maharashtra–Madhya Pradesh interstate routes, toll systems, and night driving safety.',

  top: 'Top Places to Visit in Indore with Lotus Cab',

  "topPlaces": [
    {
      "title": "Rajwada Palace",
      "description": "Rajwada Palace is a historic landmark in Indore built by the Holkar dynasty. The seven-story structure reflects a beautiful blend of Mughal and Maratha architecture. It is a must-visit heritage site for history lovers."
    },
    {
      "title": "Lal Bagh Palace",
      "description": "A grand palace showcasing European-style architecture and royal interiors representing Holkar dynasty’s opulence."
    },
    {
      "title": "Sarafa Bazaar",
      "description": "Famous night street food market offering Indore’s signature dishes like poha, jalebi, bhutte ka kees, and garadu."
    },
    {
      "title": "Patalpani Waterfall",
      "description": "A scenic waterfall near Indore ideal for nature lovers and weekend outings."
    },
    {
      "title": "Kanch Mandir",
      "description": "A unique Jain temple entirely made of glass and mirrors."
    },
    {
      "title": "Annapurna Temple",
      "description": "A beautifully designed temple dedicated to Goddess Annapurna."
    },
    {
      "title": "Ralamandal Wildlife Sanctuary",
      "description": "A forest sanctuary offering nature trails and wildlife exploration."
    },
    {
      "title": "Chappan Dukan",
      "description": "Famous food street with 56 shops offering delicious local cuisine."
    },
    {
      "title": "Tincha Falls",
      "description": "A popular monsoon waterfall attraction near Indore."
    },
    {
      "title": "Central Museum Indore",
      "description": "A museum displaying ancient sculptures and historical artifacts."
    }
  ],

  "services": [
    {
      "name": "Pune to Indore Cabs",
      "description": "Lotus Cab provides professionally managed Pune to Indore Cabs for safe and comfortable long-distance travel across state borders. The journey spans over 600 kilometers and requires skilled highway driving, route planning, and careful vehicle maintenance. Our drivers are highly experienced in interstate travel and understand toll systems, night highway safety, and long-distance fatigue management."
    },
    {
      "name": "Pune to Indore Taxi Service",
      "description": "Our Pune to Indore Taxi Service is designed for comfortable and reliable interstate highway travel with experienced drivers who specialize in long-distance routes. Vehicles are equipped for extended road trips with strong suspension, climate control, and passenger comfort features. We provide flexible departure timing and detailed trip planning support."
    },
    {
      "name": "Pune to Indore One Way Cab",
      "description": "Affordable one-way drop cab service allowing customers to pay only for single-side distance without return charges. Ideal for relocation, business travel, and long-term stay plans."
    },
    {
      "name": "Pune to Indore Round Trip Taxi",
      "description": "Flexible round-trip cab service for return planning with driver waiting coordination and scheduled return convenience."
    },
    {
      "name": "Pune to Indore Outstation Cab",
      "description": "Specialized outstation cab service ensuring interstate travel compliance, safe highway driving, and transparent fare structure."
    },
    {
      "name": "Luxury Taxi Pune to Indore",
      "description": "Premium luxury sedan and SUV options offering superior comfort for executive and VIP travel requirements."
    },
    {
      "name": "SUV Cab Pune to Indore",
      "description": "Spacious SUV vehicles ideal for group and family travel with extra luggage capacity and enhanced highway stability."
    },
    {
      "name": "Pune to Indore Long Distance Cab",
      "description": "Dedicated long-distance cab service with professionally trained drivers and vehicles prepared for extended travel duration."
    }
  ],

  "tableData": [
    ["Pune to Indore Cabs", "Pune to Indore Taxi Service"],
    ["Pune to Indore One Way Cab", "Pune to Indore Round Trip Taxi"],
    ["Pune to Indore Outstation Cab", "Affordable Pune to Indore Cab"],
    ["Luxury Taxi Pune to Indore", "SUV Cab Pune to Indore"],
    ["Cheap Pune to Indore Taxi", "Online Cab Booking Pune to Indore"],
    ["Best Cab Service Pune to Indore", "Pune to Indore Corporate Cab"],
    ["Pune to Indore Family Trip Taxi", "Pune to Indore Long Distance Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Interstate Drivers",
      "WhyChoosedescription": "Our drivers specialize in long-distance interstate routes ensuring safe, controlled, and professional highway driving across state borders."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear billing structure including per kilometer rates, toll guidance, and driver allowance details with no hidden charges."
    },
    {
      "WhyChooseheading": "Comfortable Long-Distance Vehicles",
      "WhyChoosedescription": "Well-maintained AC sedans and SUVs designed for extended highway comfort."
    },
    {
      "WhyChooseheading": "Flexible One Way & Round Trip Options",
      "WhyChoosedescription": "Choose single-side drop or return travel based on your schedule."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance",
      "WhyChoosedescription": "Round-the-clock customer support for trip coordination and booking assistance."
    },
    {
      "WhyChooseheading": "Safe Night Highway Travel",
      "WhyChoosedescription": "Drivers trained for safe and alert night travel conditions."
    },
    {
      "WhyChooseheading": "Corporate & Family Friendly",
      "WhyChoosedescription": "Vehicles suitable for business executives, family groups, and senior citizens."
    },
    {
      "WhyChooseheading": "On-Time Pickup & Coordination",
      "WhyChoosedescription": "Punctual departure from any location in Pune."
    }
  ]
}

const faqData = [
  { question: 'How long does Pune to Indore trip take?', answer: 'Approximately 10–12 hours depending on traffic and weather conditions.' },
  { question: 'Is one-way cab available?', answer: 'Yes, affordable one-way drop service is available.' },
  { question: 'Are SUVs available for group travel?', answer: 'Yes, spacious SUVs are available for comfortable group travel.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are experienced in long-distance night highway driving.' },
  { question: 'Do you provide corporate travel?', answer: 'Yes, corporate and executive bookings are available.' },
  { question: 'Is pricing transparent?', answer: 'Yes, clear per km billing with no hidden fees.' },
  { question: 'Can I book online?', answer: 'Yes, instant booking confirmation available.' },
  { question: 'Are vehicles sanitized?', answer: 'Yes, sanitized before every trip.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, recommended for long-distance travel planning.' },
  { question: 'Do you offer round-trip discounts?', answer: 'Yes, competitive round-trip pricing available.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Agrawal',
    feedback: 'Booked Pune to Indore long-distance cab with Lotus Cab. Driver was professional and handled highway driving very safely. Comfortable journey and transparent pricing made the experience excellent.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Neha Sharma',
    feedback: 'Our family trip to Indore was smooth and stress-free. Spacious SUV, punctual pickup, and reliable service. Highly recommended for interstate travel.',
    rating: 5
  }
];















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-indore-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Indore cabs with affordable one way and round trip taxi service. Book sedan, SUV, and luxury cabs for corporate travel, family trips, and long distance journeys with professional drivers and comfortable rides.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-indore-cabs"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Indore Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Indore cabs with Lotus Cab. Affordable one way & round trip taxi for corporate, family & long distance travel. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Indore Cabs, Pune to Indore Taxi Service, Pune to Indore One Way Cab, Pune to Indore Round Trip Taxi, Pune to Indore Outstation Cab, Affordable Pune to Indore Cab, Luxury Taxi Pune to Indore, SUV Cab Pune to Indore, Cheap Pune to Indore Taxi, Online Cab Booking Pune to Indore, Best Cab Service Pune to Indore, Pune to Indore Corporate Cab, Pune to Indore Family Trip Taxi, Pune to Indore Long Distance Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoindorecabs;